import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { AgendaModuleForm } from "./AgendaModuleForm";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { AGENDA_MODULE_MOTIF } from "@/lib/constants";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";

export const CreateAgendaModuleDialog = ({
  tenantId,
  isTemplate,
  disabled,
}: {
  tenantId: string;
  isTemplate: boolean;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpenChange = () => setOpen(!open);
  const handleAddAnother = () => setOpen(true);
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <Tooltip
        label={
          disabled
            ? "Select a team to create an agenda section"
            : "Create an Agenda Section"
        }
        tooltipTriggerProps={{ disabled: disabled }}
        asChild
      >
        <DialogTrigger asChild>
          <CreateTriggerButton disabled={disabled} />
        </DialogTrigger>
      </Tooltip>
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={AGENDA_MODULE_MOTIF}>
          <DialogTitle>Create An Agenda Section</DialogTitle>
        </DialogHeader>
        <AgendaModuleForm
          isTemplate={isTemplate}
          tenantId={tenantId}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          addAnother={handleAddAnother}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
